import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs';
import { CustomerService } from '../../../services/customer.service';
import { UserService } from '../../../services/user.service';
import { SessionStorageService } from '../../../services/session-storage.service';

@Component({
  selector: 'app-components-partner-accounts',
  templateUrl: './accounts.component.html'
})
export class AccountsComponent implements OnInit {
  partner: Boo.Objects.Partner;
  accounts: Boo.Objects.CustomerSearchResult[] = [];
  isLoading = false;
  hasSearched = false;

  customerStatuses = [
    { name: 'All Statuses', value: 0 },
    { name: 'Active', value: Boo.Objects.Enums.StatusEnum.Active },
    { name: 'Canceled', value: Boo.Objects.Enums.StatusEnum.Canceled }
  ];
  selectedStatus: number = Boo.Objects.Enums.StatusEnum.Active;
  searchText = '';
  searchContextText = '';

  constructor(
    private customerService: CustomerService,
    private userService: UserService,
    private sessionStorageService: SessionStorageService) {
  }

  ngOnInit(): void {
    this.sessionStorageService.getPartner()
      .subscribe({
        next: (partner) => this.partner = partner,
        error: (err) => toastr.error(err)
      });
  }

  search(): void {
    this.loadAccounts();
  }

  openSSOLink(account: Boo.Objects.CustomerSearchResult): void {
    this.userService.csrReportingAccess(account.CustomerId)
      .subscribe({
        next: (token) => window.open(`${account.ReportingUrl}/?t=${token}`, '_blank'),
        error: (err) => toastr.error(err)
      });
  }

  openReadOnlySSOLink(account: Boo.Objects.CustomerSearchResult): void {
    this.userService.readOnlyAccess(account.CustomerId)
      .subscribe({
        next: (token) => window.open(`${account.ReportingUrl}/?r=${token}`, '_blank'),
        error: (err) => toastr.error(err)
      });
  }

  copyReadOnlySSOLink(account: Boo.Objects.CustomerSearchResult): void {
    this.userService.readOnlyAccess(account.CustomerId)
      .subscribe({
        next: (token) => this.copyToClipboard(`${account.ReportingUrl}/?r=${token}`),
        error: (err) => toastr.error(err)
      });
  }

  private copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text)
      .then(() => toastr.success('Link copied to clipboard'))
      .catch(() => toastr.error('Failed to copy link'));
  }

  private loadAccounts(): void {
    this.isLoading = true;
    this.hasSearched = true;
    this.accounts = [];
    this.searchContextText = this.searchText.trim();

    const searchAllStatuses = this.selectedStatus === 0;
    const searchActiveCustomers = this.selectedStatus === Boo.Objects.Enums.StatusEnum.Active;

    this.customerService.search(
      this.searchContextText,
      this.partner.PartnerId,
      1,
      10000,
      0,
      true,
      false,
      searchAllStatuses,
      searchActiveCustomers
    )
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (data) => {
          if (data && data.length > 0) {
            data.forEach((account) => {
              account.Products = account.Products?.replace('\\r\\n', '<br />') ?? '';
            });
            this.accounts = data;
          }
        },
        error: (err) => toastr.error(err)
      });
  }
}
